
import SearchFiltersDesktop from './desktop';
import SearchFiltersMobile from './mobile';
import { StyleSizeType } from '@/ui-kit/styles/enums';
import SearchFiltersEvents from '../mixins/SearchFiltersEvents';

export default {
  name: 'SearchFilters',
  components: {
    SearchFiltersDesktop,
    SearchFiltersMobile,
  },
  mixins: [SearchFiltersEvents],
  props: {
    filters: {
      default: () => ({}),
      type: Object,
    },
    resetButtonText: {
      required: true,
      type: String,
    },
    submitButtonText: {
      required: true,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      StyleSizeType,
    };
  },
  methods: {
    handleFiltersChange(value) {
      this.emitChange(value);
    },
    handleFiltersReset() {
      this.emitReset();
    },
  },
};
